/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isArray.js
// module id = 128
// module chunks = 2